import { remove } from '@user/store/services/crud'
import { baseUrl } from '../constants'
import { toast } from '@sales-center/components'
import { deleteActivityTypeActionCreator } from '../state'

export async function deleteActivityType(id: string) {
  const response = await remove(`${baseUrl}/${id}`)

  if (!response.ok) {
    toast.error('Failed to delete Activity Type')
    return deleteActivityTypeActionCreator()
  }

  return deleteActivityTypeActionCreator(id)
}
